<script setup>
import { googleTokenLogin } from 'vue3-google-login'
// import Login from "./login.vue"
import { sendCodeAPI } from '@/apis/user'
import slideVerify from "@/components/slideVerify/index.vue"
import { ElMessage } from 'element-plus'
import { useCartStore } from '@/stores/cartStore'
import 'element-plus/theme-chalk/el-message.css'
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore'
import { useI18n } from 'vue-i18n'
const cartStore = useCartStore()
const { t, locale } = useI18n();
const Props = defineProps({
    loginType: {
        type: String,
    },
    type: {
        type: String,
    },
    ispopup: {
        type: Boolean,
        default: true
    }

})
// const Props = defineProps(['loginType', 'type', 'ispopup'])
const emits = defineEmits(['close', 'checkType'])
const userStore = useUserStore()
const router = useRouter()
const isMobile = ref(false)
const showtg = ref(false)
onMounted(async () => {
    // npm install vue-meta@3.0.0-alpha.7
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    window.addEventListener("keydown", enterdown);
    if(window.Telegram.WebApp.initData!==""){
        showtg.value=true
        console.log('showtg',window.Telegram.WebApp.initData,window.Telegram.WebApp)
    }
   
});
const verify = () => {
    formRef.value.validate(async (valid) => {
        if (valid) {
            state.verifiedModel = true
        }
    });
}
const checkType = (type) => {
    emits('checkType', type)
    router.push('/login')
    localStorage.setItem('loginType', type)
}
onUnmounted(() => {
    window.removeEventListener("keydown", enterdown, false);
});
function enterdown(e) {
    if (e.keyCode == 13) {
        verify() // 需要执行的方法方法
    }
}
// 封装数据获取函数
const getAuthData = () => {
    try {
        const tg = window.Telegram.WebApp;
        if (!tg) throw new Error('Telegram SDK 未加载');

        // 显示加载状态
        document.getElementById('status').textContent = '正在获取数据...';
        document.getElementById('auth-data').style.display = 'none';

        // 模拟异步获取（实际是同步操作）
        setTimeout(async () => {
            const initData = tg.initData || {};
            const initDataUnsafe = tg.initDataUnsafe || {};
            if (!initDataUnsafe.user) {
                
                ElMessage({ type: 'error', message: '未获取到用户信息' })
                return
            }
            const authData = {
                initData: initData,
                userInfo: {
                    id: initDataUnsafe.user?.id,
                    firstName: initDataUnsafe.user?.first_name,
                    lastName: initDataUnsafe.user?.last_name,
                    username: initDataUnsafe.user?.username,
                    language: initDataUnsafe.user?.language_code,
                },
                authDate: new Date(initDataUnsafe.auth_date * 1000),
                chatId: initDataUnsafe.chat?.id,
                hash: initData.hash
            };
            await userStore.getTelegramUserInfo({ init_data: initData })

            // 1. 提示用户
            ElMessage({ type: 'success', message: t('login28') })
            if (Props.type == 1) {
                emits('close')
                userStore.getUser()

            } else {
                // 2. 跳转首页
                router.replace({ path: '/' })
                emits('close')
            }
            // 显示数据
            const displayElement = document.getElementById('auth-data');
            displayElement.textContent = JSON.stringify(authData, null, 2);
            displayElement.style.display = 'block';
            document.getElementById('status').textContent = '数据获取成功 ✓';

            // 发送到服务端的示例（需实现）
            /*
            fetch('/verify', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(authData.initData)
            });
            */
        }, 300); // 模拟延迟

    } catch (error) {
        console.log('err0r')
        ElMessage({ type: 'error', message: error.message })

        document.getElementById('status').textContent = `错误: ${error.message}`;
        document.getElementById('auth-data').style.display = 'none';
    }
}

// 绑定按钮点击事件
const state = reactive({
    loginType: Props.loginType,

    areaCodeList: [],
    form: {
        username: '',
        code: null,
        password: null,
        loginType: 1,

    },

});
const gologin = () => {
    router.push('/login')
}
// 登录成功后的回调函数
const callback = async (response) => {
    await userStore.getGoogleUserInfo({ jwt_token: response.credential })

    // 1. 提示用户
    ElMessage({ type: 'success', message: t('login28') })
    if (Props.type == 1) {
        emits('close')
        userStore.getUser()
       
    } else {
        // 2. 跳转首页
        router.replace({ path: '/' })
        emits('close')
    }


}
//验证
const login = () => {
    try {
        googleTokenLogin().then(async (response) => {
            console.log('response.access_token', response.access_token)
            await userStore.getGoogleUserInfo({ access_token: response.access_token })

            // 1. 提示用户
            ElMessage({ type: 'success', message: t('login28') })
            if (Props.type == 1) {
                emits('close')
                userStore.getUser()
               
            } else {
                // 2. 跳转首页
                router.replace({ path: '/' })
                emits('close')
            }
            cartStore.updateNewList()
        })
    } catch (error) {
        console.log('error', error)
    }

}
//验证
const handle = () => {
    doLogin()
}
const doLogin = () => {
    state.verifiedModel = false
    // 调用实例方法
    formRef.value.validate(async (valid) => {
        console.log(valid)
        if (valid) {
            state.form.code = parseInt(state.form.code)
            await userStore.getUserInfo(state.form)

            // 1. 提示用户
            ElMessage({ type: 'success', message: t('login28') })
            if (Props.type == 1) {
                emits('close')
                userStore.getUser()
             
            } else {
                // 2. 跳转首页
                router.replace({ path: '/' })
                emits('close')
            }
            cartStore.updateNewList()


        }
    })
}

const formRef = ref(null)

// 2. 准备规则对象
const rules = {

    username: [
        { required: true, message: t('login29'), trigger: 'blur' },
        { type: 'email', message: t('login21'), trigger: 'blur' },

    ],
    password: [
        { required: true, message: t('login24'), trigger: 'blur' },
        { min: 6, message: t('login25'), trigger: 'blur' }
    ],

}

</script>
<template>
    <div>
        <div class="loginPage" :class="ispopup ? 'popup-view' : ''">
            <div class="sub-title" v-if="loginType == 1">LOGIN
            </div>
            <div class="form">
                <el-form ref="formRef" :model="state.form" size="large" :rules="rules" label-position="top"
                    label-width="60px">


                    <el-form-item prop="username" :label="''" class="form-item">
                        <el-input class="form-input" v-model="state.form.username" :placeholder="$t('login31')">
                            <!-- <template #prefix>
                                <svg-icon icon-class="user" />
                            </template> -->
                        </el-input>

                    </el-form-item>
                    <el-form-item prop="password" :label="''" class="form-item">
                        <el-input v-model="state.form.password" type="password" show-password
                            :placeholder="$t('login10')">
                            <!-- <template #prefix>
                                <svg-icon icon-class="password" />
                            </template> -->
                        </el-input>
                    </el-form-item>
                    <el-button size="large" type="primary" class="subBtn" @click="verify()" @keyup.enter="enterdown">{{
                        $t("login32")
                        }}</el-button>
                </el-form>

            </div>
        </div>
        <div class="login-bottom" v-show="loginType == 1" :style="isMobile && ispopup ? 'padding:10px 0' : ''">
            <div @click="checkType(3)">{{ $t("login5") }}</div>
            <div @click="checkType(2)" class="btn-reg"
                :style="isMobile ? ispopup ? 'display:block' : 'display:none' : 'display:block'">
                {{ $t("login6") }}</div>
        </div>
        <div class="googleline" @click="login" :style="isMobile && ispopup ? 'margin:10px 0' : ''">
            <svg-icon icon-class="google" style="width: 24px;height: 24px;margin-right: 5px;" />
            <div> {{ $t("setup581") }}</div>
            <!-- <GoogleLogin :callback="callback" style="width: 100%;" /> -->
        </div>
        <div class="googleline" v-if="showtg" @click="getAuthData" :style="isMobile && ispopup ? 'margin:10px 0' : ''">
            <svg-icon icon-class="telegram" style="width: 24px;height: 24px;margin-right: 5px;" />
            <div id="action-btn"> {{ $t("setup584") }}</div>
        </div>
        <div style="height: 0;opacity: 0;">
            <div class="container">
                <!-- <button id="action-btn" @click="getAuthData">获取验证信息</button> -->
                <div class="status-text" id="status">点击上方按钮获取验证数据</div>
                <pre id="auth-data"></pre>
            </div>
        </div>
        <el-dialog v-model="state.verifiedModel" width="350px" v-if="isMobile == false" lock-scroll>
            <!-- 滑动拼图验证区  @verified="loginverified"-->
            <slideVerify v-if="state.verifiedModel" @handle="handle"></slideVerify>
        </el-dialog>
        <el-drawer v-else show-close :with-header="true" size="70%" direction="btt" v-model="state.verifiedModel" lock-scroll>
            <!-- 滑动拼图验证区  @verified="loginverified"-->
            <slideVerify v-if="state.verifiedModel" @handle="handle"></slideVerify>
        </el-drawer>
    </div>
</template>
<style scoped lang="scss">
.phone {
    display: none;
}

.pc {
    display: block;
}

.loginPage {

    .nameType {
        font-size: 20px;
        padding: 30px 0 0 0;
        display: flex;
        justify-content: space-between;
        font-weight: bold;

        .check {
            color: #58a8fd;
        }

        .nocheck {
            color: #484848;
        }
    }

    .login-type {
        // padding-left: 20px;
        font-size: $formSize;
        line-height: 19px;
        color: #A3A3A3;
        margin: 30px 0 20px 0;

    }

    .sub-title {
        font-family: MicrosoftYaHei;
        font-size: 24px;
        color: #11192D;
        line-height: 31px;
        text-align: left;
        font-style: normal;
        margin: 20px 0 16px;
    }

    .subBtn {
        width: 100%;
        height: 52px;
        margin: 20px 0 10px;
    }
}

.googleline {
    margin: 10px 0 0;
    border: 1px solid #dbdbe2;
    border-radius: 8px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

}

.login-bottom {

    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    // color: #56a9ff;
    font-size: $formSize;

    >div:first-child {
        color: #666666;
    }

    >div:last-child {
        color: #FF9845;
    }
}

#login-status {
    margin-top: 20px;
    color: green;
}

@media (max-width: 768px) {
    .pc {
        display: none;
    }

    .phone {
        display: block;
    }

    .googleline {
        margin: 10px 20px 0;
    }

    .login-bottom {

        display: flex;
        justify-content: space-between;
        padding: 0px 20px 10px;
        color: #56a9ff;
        // font-size: $formSize;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 14px;
        font-style: normal;
    }



    .form {
        padding: 20px 20px;

        .subBtn {
            border-radius: 26px;
        }
    }

    .loginPage {
        margin: 0 auto;

        .sub-title {
            display: none;
        }
    }

    .popup-view {
        .sub-title {
            display: block;
            // padding: 0 15px;
        }

        .form {
            padding: 0 0;
        }
    }

    // .btn-reg {
    //     display: none;
    // }

    :deep(.el-input__wrapper) {
        // position: relative;
        // top:-1px;
        // left: 0;
        height: 52px;
        border-radius: 26px;
        overflow: hidden;
        background-color: #f4f5f6;
    }


}
</style>